import {
  Mountain,
  Leaf,
  Palmtree,
  Sprout,
  Flame,
  Palette,
  ChefHat,
  HelpingHand,
  Baby,
  Heart,
  Amphora,
  TreePine,
  Waves,
  Sun,
  Snowflake,
  Building2,
  Tent,
  PersonStanding,
  Users,
} from 'lucide-vue-next'

const freezeOptions = (options) => Object.freeze(options.map((option) => Object.freeze(option)))

// ─── Legacy options (used by the desktop refine tabs: Themes, Travel Method, etc.) ─────────────

export const themeOptions = freezeOptions([
  { id: 'adventure', label: 'Adventure', icon: '🏔️' },
  { id: 'nature', label: 'Nature', icon: '🌿' },
  { id: 'cultural', label: 'Cultural / Historical', icon: '🏛️' },
  { id: 'eco-friendly', label: 'Eco-friendly', icon: '♻️' },
  { id: 'wellbeing', label: 'Wellbeing', icon: '🧘' },
  { id: 'culinary', label: 'Culinary', icon: '🍽️' },
  { id: 'community', label: 'Community / Volunteer', icon: '🤝' },
  { id: 'creative', label: 'Creative', icon: '🎨' },
  { id: 'family', label: 'Family', icon: '👨‍👩‍👧‍👦' },
  { id: 'shop', label: 'Shop', icon: '🛍️' },
  { id: 'extreme-sports', label: 'Extreme Sports', icon: '🏄' },
])

export const travelMethodOptions = freezeOptions([
  { id: 'car', label: 'Car', icon: '🚗' },
  { id: 'motorbike', label: 'Motorbike', icon: '🏍️' },
  { id: 'bicycle', label: 'Bicycle', icon: '🚴' },
  { id: 'campervan', label: 'Campervan', icon: '🚐' },
  { id: 'air', label: 'Air', icon: '✈️' },
  { id: 'train', label: 'Train', icon: '🚆' },
  { id: 'coach', label: 'Coach', icon: '🚌' },
  { id: 'yacht', label: 'Yacht', icon: '🛥️' },
  { id: 'cruise', label: 'Cruise', icon: '🚢' },
])

export const accommodationOptions = freezeOptions([
  { id: 'hotel', label: 'Hotel', icon: '🏨' },
  { id: 'motel', label: 'Motel', icon: '🏩' },
  { id: 'airbnb', label: 'Airbnb', icon: '🏠' },
  { id: 'homestay', label: 'Home stay', icon: '🏡' },
  { id: 'farmstay', label: 'Farm stay', icon: '🚜' },
  { id: 'eco-lodge', label: 'Eco-lodge', icon: '🌲' },
  { id: 'hostel', label: 'Hostel', icon: '🎒' },
  { id: 'boat', label: 'Boat', icon: '⛵' },
  { id: 'campsite', label: 'Campsite', icon: '⛺' },
  { id: 'cabin', label: 'Cabin', icon: '🏘️' },
])

export const specialRequirementsOptions = freezeOptions([
  { id: 'wheelchair-access', label: 'Wheelchair Access', icon: '♿' },
  { id: 'service-animal-friendly', label: 'Service Animal Friendly', icon: '🦮' },
  { id: 'pet-friendly', label: 'Pet Friendly', icon: '🐕' },
])

// ─── Refine form options (icon-grid style, using Lucide components) ───────────────────────────

export const regionOptions = Object.freeze([
  { id: 'africa', label: 'Africa' },
  { id: 'asia', label: 'Asia' },
  { id: 'north-america', label: 'North America' },
  { id: 'central-america', label: 'Central America' },
  { id: 'south-america', label: 'South America' },
  { id: 'europe', label: 'Europe' },
  { id: 'middle-east', label: 'Middle East' },
  { id: 'oceania', label: 'Oceania' },
  { id: 'polar', label: 'Polar Regions' },
])

export const tripTypeOptionsDiscover = freezeOptions([
  { id: 'coastal', label: 'Coastal', icon: Waves },
  { id: 'desert', label: 'Desert', icon: Sun },
  { id: 'snow', label: 'Snow', icon: Snowflake },
  { id: 'tropical', label: 'Tropical', icon: Palmtree },
  { id: 'urban', label: 'Urban', icon: Building2 },
  { id: 'countryside', label: 'Country', icon: TreePine },
  { id: 'remote', label: 'Remote', icon: Tent },
  { id: 'ancient', label: 'Ancient', icon: Amphora },
  { id: 'romantic', label: 'Romantic', icon: Heart },
  { id: 'creative', label: 'Creative', icon: Palette },
])

export const tripTypeOptionsPlan = freezeOptions([
  { id: 'adventure', label: 'Adventure', icon: Mountain },
  { id: 'cultural', label: 'Cultural', icon: Amphora },
  { id: 'relaxing', label: 'Relaxing', icon: Palmtree },
  { id: 'eco-friendly', label: 'Eco-friendly', icon: Leaf },
  { id: 'wellness', label: 'Wellness', icon: Sprout },
  { id: 'nature', label: 'Nature', icon: TreePine },
  { id: 'extreme-sports', label: 'Extreme sports', icon: Flame },
  { id: 'creative', label: 'Creative', icon: Palette },
  { id: 'culinary', label: 'Culinary', icon: ChefHat },
  { id: 'community', label: 'Community', icon: HelpingHand },
  { id: 'family-friendly', label: 'Family Friendly', icon: Baby },
  { id: 'romantic', label: 'Romantic', icon: Heart },
])

export const whoIsGoingOptions = freezeOptions([
  { id: 'solo', label: 'Solo', icon: PersonStanding },
  { id: 'couple', label: 'Couple', icon: Heart },
  { id: 'family', label: 'Family', icon: Users },
])

// ─── Distance slider config ───────────────────────────────────────────────────────────────────

export const distanceOptions = Object.freeze([
  { id: 'day', label: 'Day trip', maxHours: 3, step: 0.25, default: 2 },
  { id: 'weekend', label: 'Weekend Trip', maxHours: 8, step: 0.5, default: 4 },
  { id: 'long', label: 'Long Distance', maxHours: 24, step: 1, default: 6 },
])
